import React from 'react';
import { Container } from 'react-bootstrap';

export const AwpContainer = ({ children, fluid = false }) => {
  return (
    <Container className="mt-4 wrapper flex-grow-1" fluid={fluid}>
      {children}
    </Container>
  );
};
